/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid } from '@coursera/cds-core';

import ConsumerSearchBarGridItem from 'bundles/composable-page-header-consumer/components/ConsumerSearchBarGridItem';
import ExploreMegaMenuGridItem from 'bundles/composable-page-header-consumer/components/ExploreMegaMenuGridItem';
import MainNavigationWrapper from 'bundles/composable-page-header/components/MainNavigationWrapper';
import NavLinkGridItem from 'bundles/composable-page-header/components/grid-items/NavLinkGridItem';
import UnauthenticatedActionsGridItem from 'bundles/composable-page-header/components/grid-items/UnauthenticatedActionsGridItem';
import CourseraHomeLogo from 'bundles/composable-page-header/components/grid-items/home-logo/CourseraHomeLogo';
import HomeLogoGridItemModule from 'bundles/composable-page-header/components/grid-items/home-logo/HomeLogoGridItemModule';
import { logInButtonProps, signUpButtonProps } from 'bundles/composable-page-header/constants';
import { getShouldShowCourseraPlusEntrypointInNav } from 'bundles/coursera-plus-common/utils/subscriptionsForwardDiscoveryExperiment';
import GrowthDiscoveryExperiments from 'bundles/epic/clients/GrowthDiscovery';

import _t from 'i18n!nls/composable-page-header-consumer';

const styles = {
  leftSide: css`
    width: auto;
  `,
  middleSide: css`
    flex-shrink: 1;
    flex-grow: 1;
    flex-basis: 0%;
    padding: 0 16px;
    width: 100%;
  `,
  rightSide: css`
    width: auto;
  `,
};

type Props = {
  showSearchBar?: boolean;
};

const LoggedOutConsumerDesktopMainNav = ({ showSearchBar = true }: Props) => {
  const showCPlusLink = getShouldShowCourseraPlusEntrypointInNav();

  // If learner is in the experiment hide the search bar on LOHP until they scroll past the hero banner
  const hideSearchBarInNav = GrowthDiscoveryExperiments.preview('showSearchBannerOnLOHP');
  const shouldShowSearchBar = hideSearchBarInNav ? showSearchBar : true;

  return (
    <MainNavigationWrapper>
      <Grid item container alignItems="center" spacing={16} css={styles.leftSide}>
        <Grid item>
          <HomeLogoGridItemModule href="/" logos={[<CourseraHomeLogo key="1" />]} className="c-logo" />
        </Grid>
        <Grid item>
          <ExploreMegaMenuGridItem />
        </Grid>
      </Grid>
      <Grid item container alignItems="center" css={styles.middleSide}>
        {shouldShowSearchBar && <ConsumerSearchBarGridItem />}
      </Grid>
      <Grid item container alignItems="center" justifyContent="flex-end" wrap="nowrap" css={styles.rightSide}>
        {showCPlusLink ? (
          <NavLinkGridItem
            label={_t('Coursera Plus')}
            href="/courseraplus"
            name="coursera_plus"
            trackingName="logged_out_coursera_plus"
          />
        ) : (
          <React.Fragment>
            <NavLinkGridItem
              label={_t('Online Degrees')}
              href="/degrees"
              name="online_degrees"
              trackingName="logged_out_online_degrees"
            />
            <NavLinkGridItem
              label={_t('Careers')}
              href="/career-academy"
              name="online_career"
              trackingName="logged_out_career_academy"
            />
          </React.Fragment>
        )}
        <UnauthenticatedActionsGridItem buttons={[logInButtonProps(), signUpButtonProps()]} />
      </Grid>
    </MainNavigationWrapper>
  );
};

export default LoggedOutConsumerDesktopMainNav;
